import { Loader2 } from "lucide-react";
import { useTranslation } from "@/hooks/useTranslation";

export function PageLoader() {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] animate-fade-in">
      <div className="relative">
        <div className="absolute inset-0 rounded-full bg-primary/10 animate-ping" style={{ animationDuration: "1.5s" }} />
        <div className="relative flex items-center justify-center w-16 h-16 rounded-full bg-primary/5">
          <Loader2 className="w-8 h-8 text-primary animate-spin" />
        </div>
      </div>
      <p className="mt-4 text-sm text-muted-foreground">{t("message.loading", "Carregando...")}</p>
    </div>
  );
}
